export default "__VITE_ASSET__0cba73c9__"